import { CanDeactivateFn } from '@angular/router';

export interface DirtyFormAware {
  canDeactivate(): boolean;
}

export const dirtyFormGuard: CanDeactivateFn<DirtyFormAware> = (component) =>
  component.canDeactivate();
